import { defineComponent } from 'vue';
import CategoryElevenComponent from '@/components/CategoryEleven/CategoryElevenComponent.vue';
export default defineComponent({
    name: 'CategoryElevenDuplicateDialog',
    props: {
        propSelected: Array,
        propId: String
    },
    components: { CategoryElevenComponent },
    data: function () {
        return {
            show: false,
            id: this.propId
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
